import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/lib/api';
import AdForm from '@/pages/dashboard/AdForm';
import ErrorBoundary from '@/components/common/ErrorBoundary';

export default function EditAdPage() {
    const { id } = useParams();
    const [initial, setInitial] = useState(null);

    useEffect(() => { api.get(`/ads/${id}`).then(r => setInitial(r.data)); }, [id]);

    const submit = async (payload) => {
        const { data } = await api.put(`/ads/${id}`, payload);
        return data;
    };

    if (!initial) return <div className="text-sm text-muted-foreground">Cargando…</div>;

    return (
        <div className="space-y-4">
            <h1 className="text-xl font-semibold tracking-tight">Editar anuncio</h1>
            <ErrorBoundary>
                <AdForm initial={initial} onSubmit={submit} submitLabel="Guardar cambios" />
            </ErrorBoundary>
        </div>
    );
}
